
import Header from "../../components/ui/header/theme_navbar";
import Footer from "../landing-page/theme_footer";
import styles from '../../styles/contactUs-page.module.scss'
import ContactUsTheme from "../contact-us/theme_test";
import ColorSelector from "../contact-us/theme_design";
import { Grid } from "@mui/material";
import { ThemeProvider } from "../themeContext";

const ContactThemeGenerate: React.FC = () => {

    return (
        <ThemeProvider>
        <Grid container>
            <Grid item md={3} xs={12} sm={12}>
                <ColorSelector />
            </Grid>
            <Grid item md={9} xs={12} sm={12}>
                <Header className={styles.headerBlack}  />
                    < ContactUsTheme />
                <Footer />
            </Grid>
        </Grid>
        </ThemeProvider>
    )
}

export default ContactThemeGenerate;